import moment from "moment";

// types
import { ProfileSBACertsExtended } from "types/profile.types";

// store
import { ProfileSBACerts } from "store/searchStore";

// utils
import { refineCertificationTags } from "./helper";

export function getCurrentSBACertificates(
  certs?: ProfileSBACerts[]
): ProfileSBACertsExtended[] {
  if (!certs) {
    return [];
  }

  return certs
    .filter((x) => x?.status === "Active")
    .map((cert) => {
      const tag = refineCertificationTags(
        cert.name,
        cert.pending?.indexOf("Y") > -1
      );

      return {
        ...cert,
        tag,
      };
    });
}

export function getPastSBACertificates(
  certs?: ProfileSBACerts[]
): ProfileSBACertsExtended[] {
  if (!certs) {
    return [];
  }

  return certs
    .filter(
      (x) => x?.status !== "Active" && x?.status?.toLowerCase() !== "suspended"
    )
    .map((cert) => {
      const tag = refineCertificationTags(
        cert.name,
        cert.pending?.indexOf("Y") > -1
      );

      return {
        ...cert,
        tag,
      };
    });
}

export function getSuspendedSBACertificates(
  certs?: ProfileSBACerts[]
): ProfileSBACertsExtended[] {
  if (!certs) {
    return [];
  }

  return certs
    .filter((x) => x?.status?.toLowerCase() === "suspended")
    .map((cert) => {
      const tag = refineCertificationTags(cert.name, false);

      return {
        ...cert,
        tag,
      };
    });
}

export function getSBACertTitle(tagName: string) {
  switch (tagName) {
    case "8(a)":
      return "8(a) Business Development Program";
    case "8(a) JV":
      return "8(a) Joint Venture";
    case "HUBZone":
      return "HUBZone certified";
    case "WOSB":
      return "Women-Owned Small Business (WOSB)";
    case "EDWOSB":
      return "Economically-Disadvantaged Women-Owned Small Business (EDWOSB)";
    case "VOSB":
      return "Veteran-Owned Small Business (VOSB)";
    case "VOSB JV":
      return "Veteran-Owned Joint Venture (VOSB JV)";
    case "SDVOSB":
      return "Service-Disabled Veteran-Owned Small Business (SDVOSB)";
    case "SDVOSB JV":
      return "Service-Disabled Veteran-Owned Joint Venture (SDVOSB JV)";
    default:
      return "";
  }
}

export function formatCertDate(date: string) {
  if (!date) return "";

  return moment(date).format("MMMM D, YYYY");
}

export function ensureLeading$(value: string) {
  if (!value) return "";

  return value[0] === "$" ? value : `$${value}`;
}